import React from "react";
import { useNavigate } from "react-router-dom";
;
import { IconArrowLeft } from "@velaro/velaro-component-lib/";
import IconByName from "@/components/ds/IconByName";

import { PrimaryButton } from "@/components/ds";

export default function DynamicsOverview() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="font-semibold group flex items-center gap-2 justify-between mb-6">
        <div className="flex items-center gap-2">
          <div className="w-14 h-14 border-zinc-300 relative mr-4 rounded border p-2 content-center flex items-center justify-center">
            <img src="/img/ms-dynamics-365.svg" alt="Microsoft Dynamics 365" className="w-10 h-10" />
          </div>
          <div>
            <div className="font-semibold text-slate-gray-800 text-lg">Microsoft Dynamics 365</div>
            <div className="font-normal text-slate-gray-400 text-sm">
              Connect Dynamics 365 to look up contacts, accounts, and leads — and create CRM records directly from conversations.
            </div>
          </div>
        </div>
        <PrimaryButton
          label="Connect Dynamics 365"
          onClick={() => navigate("/integrations/dynamics/create")}
          prefixIcon={null}
          className="font-medium"
        />
      </div>

      <div className="flex border-b mb-4">
        <div className="py-2 mr-4 cursor-pointer text-zinc-800 text-sm border-b-2 border-b border-zinc-600 px-3">
          Overview
        </div>
      </div>

      <div className="text-sm text-zinc-800 space-y-3">
        <p>
          Connect Microsoft Dynamics 365 CRM so your agents can instantly pull up contact history, account details, open opportunities, and support cases — all within Velaro, without switching tabs.
        </p>
        <p>
          AI workflow nodes can query Dynamics 365 to search contacts and accounts, create new leads automatically when a visitor provides their email, and push full chat transcripts as notes on any record.
        </p>
        <p>
          Rules engine integration lets you automatically create Dynamics 365 records (Contacts, Leads, Accounts, Cases) when conversations match conditions — closing the loop between your chat and CRM without agent involvement.
        </p>
      </div>

      {/* AppSource badge */}
      <div className="mt-4 flex items-center gap-3 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="text-blue-700"><IconByName name="Building" className="w-6 h-6" /></div>
        <div>
          <div className="text-sm font-semibold text-blue-800">Available on Microsoft AppSource</div>
          <div className="text-xs text-blue-700 mt-0.5">
            Velaro is a Microsoft partner app with native Entra ID login and Dynamics 365 integration.
            Find us on AppSource to deploy with a single click into your Microsoft 365 environment.
          </div>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          {
            title: "Contact & Account Lookup",
            desc: "Search Dynamics 365 contacts and accounts by email or name during live chats. See deal stage, case history, and account details.",
            icon: "Search"
          },
          {
            title: "CRM Record Creation",
            desc: "Use the rules engine to automatically create Leads, Contacts, or Cases in Dynamics 365 when conversations match your conditions.",
            icon: "Plus"
          },
          {
            title: "AI Workflow Tools",
            desc: "Workflow AI nodes can query contacts, create leads, and push chat transcripts as notes — fully automated, no agent needed.",
            icon: "Bot"
          }
        ].map((f) => (
          <div key={f.title} className="rounded-lg border border-zinc-200 p-4">
            <div className="text-zinc-600 mb-2"><IconByName name={f.icon} className="w-6 h-6" /></div>
            <div className="font-medium text-zinc-800 text-sm mb-1">{f.title}</div>
            <div className="text-xs text-zinc-500">{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function DynamicsBackToIntegrationLanding() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-zinc-600" onClick={() => navigate("/integrations")}>
      <IconArrowLeft className="h-6 w-6" />
      Back
    </div>
  );
}

export function DynamicsBackToOverview() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-zinc-600" onClick={() => navigate("/integrations/dynamics/overview")}>
      <IconArrowLeft className="h-6 w-6" />
      Back to Dynamics 365
    </div>
  );
}
